import { createModel } from "@rematch/core";
import { ClusterState, DashboardFilterState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: ClusterState = {
  data: [],
  loading: false,
  pending: null,
};

export const cluster = createModel<RootModel>()({
  state: initialState as ClusterState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Array<{ date: string; min: number; mid: number; max: number }>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(
        {
          data: payload,
        },
        state,
        requestId
      );
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchCluster(dashboardFilter: DashboardFilterState, rootState) {
      const requestId = multiRequest.getRequestId();
      dispatch.cluster.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.cluster.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const clusterResult = await api.fetchCluster(token, dashboardFilter);
        dispatch.cluster.fetchSuccess(clusterResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.cluster.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/cluster.ts